/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import DefaultCrudTable from '@/components/tables/DefaultCrudTable'
import RegularTemplate from '@/components/templates/RegularTemplate'
import React from 'react'
import CustomTableBody from './components/CustomTableBody'
import ButtonLink from '@/components/buttons/ButtonLink'
import { assetsBatchesUrls } from '@/configs/urls'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAssetsBatches } from '@/services/asset-batches'
import { assetBatchStatus, columns } from './handlers'
import MainTotalItems from '@/components/listings/MainTotalItems'
import { ASSET_REGISTER_BATCHES, REGISTER_ASSETS } from '@/configs/strings/register-multiple-assets'
import { CREATE_ASSET_REGISTRATION_BATCH } from '@/configs/strings/assets'
import { useBreakpointValue } from '@chakra-ui/react'
import FilterBatchList from '@/components/listings/FilterBatchList'

const AssetsBatchesList = () => {
  const { base, create } = assetsBatchesUrls
  const urlCreate = `/${base}/${create}`
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    searchParams,
    setSearchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getAssetsBatches
  })
  const fontSize = useBreakpointValue({
    base: '!text-sm',
    sm: ''
  })
  const CreateButton = () => (
    <ButtonLink
      to={urlCreate}
      className={`uppercase ${fontSize}`}
    >
      { CREATE_ASSET_REGISTRATION_BATCH }
    </ButtonLink>
  )

  return (
    <RegularTemplate
      title= {REGISTER_ASSETS}
      childrenHeader={CreateButton}
      loadingContent={loading}
    >
      { itemsResponse && !loading &&
        <>
          <FilterBatchList
            className="mb-3"
            onFilterResults={(filter) => setSearchParams(filter)}
            onReset={() => setSearchParams({})}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            statusOptions={assetBatchStatus}
          />
          <MainTotalItems
            label={ASSET_REGISTER_BATCHES}
            total={itemsResponse.total}
            className="mb-3"
          />
          <DefaultCrudTable
            page={page}
            loading={loading}
            totalPages={totalPages}
            onPageChange={(page) => onChangePage(page)}
          >
            <DefaultCrudTable.Header
              columns={columns}
              actionsTitle="ACTIONS"
            />
            <CustomTableBody
              columns={columns}
              items={itemsResponse.data}
            />
          </DefaultCrudTable>
        </>
      }
    </RegularTemplate>
  )
}

export default AssetsBatchesList
